import InventoryListingAddOns from './InventoryListingAddOns';
export default InventoryListingAddOns;